import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-homepage-three',
    templateUrl: './homepage-three.component.html',
    styleUrls: ['./homepage-three.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomepageThreeComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}